import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=f3d0f53e"
import script from "./IconButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports